import { FC, ReactNode } from 'react';

import styled from 'styled-components';

import DeleteSvg from '@assets/icons/drawer/delete.svg';
import { OriginalPrice } from '@components/ui/price';
import { Col, Row } from '@components/formStyles';

export const IconDeleteContainer = styled.div`
  display: flex;
  height: 25px;
`;

export const IconDelete = styled(DeleteSvg)`
  fill: ${({ theme }) => theme.palette.white};
  display: flex;
  align-self: center;
  margin-left: 10px;

  cursor: pointer;
`;

export const LeftSelectedContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LeftSelectedItem = styled.div`
  display: flex;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: space-between;
    width: 100%;
  }
`;

export const ItemBoldText = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.grey1100};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 14px;
    margin-right: 10px;
  }
`;

export const ItemText = styled.span`
  font-size: 16px;
  font-weight: normal;
  color: ${({ theme }) => theme.palette.matterHorn};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    font-size: 14px;
  }
`;

export const PriceField = styled.div`
  font-size: 16px;
  font-weight: 600;
  width: 140px;

  text-align: right;
`;

export const ListItemCircle = styled.div`
  width: 3px;
  height: 3px;
  border-radius: 3px;
  justify-content: center;
  margin-left: 5px;
  margin-right: 5px;
  background-color: ${({ theme }) => theme.palette.grey200};
`;

export const WarningMessage = styled.span`
  margin: 3px 0 0;
  opacity: 0.5;
  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const ItemsCol = styled(Col)`
  flex: 1;
`;

export const ItemContentRow = styled(Row)`
  flex-wrap: wrap;
`;

const Item: FC<{
  price: number;
  content: ReactNode;
  currency: string;
  onRemove?: (id: string | number) => void;
  showPrice: boolean;
}> = ({ price, content, onRemove, currency, showPrice }) => (
  <LeftSelectedContainer>
    <LeftSelectedItem>
      {content}
      {onRemove ? (
        <IconDeleteContainer>
          <IconDelete title='remove' onClick={onRemove} />
        </IconDeleteContainer>
      ) : null}
    </LeftSelectedItem>
    {showPrice ? (
      <PriceField>
        <OriginalPrice price={price} currency={currency} noLine />
      </PriceField>
    ) : null}
  </LeftSelectedContainer>
);

export default Item;
